module.exports = "/static/images/mtns.jpg";